module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "flatpickr input-group"
  }, [_c('input', {
    ref: "datepicker",
    staticClass: "form-control datepicker",
    attrs: {
      "type": "text",
      "placeholder": "Seleccione una fecha",
      "data-input": ""
    }
  }), _vm._v(" "), _vm._m(0), _vm._v(" "), _c('a', {
    staticClass: "input-group-addon",
    attrs: {
      "data-clear": ""
    },
    on: {
      "click": _vm.onClickClear
    }
  }, [_c('i', {
    staticClass: "fa fa-close"
  })])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('a', {
    staticClass: "input-group-addon",
    attrs: {
      "data-toggle": ""
    }
  }, [_c('i', {
    staticClass: "fa fa-calendar"
  })])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-7bfe5004"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Shared/DatePicker.vue
// module id = 1148
// module chunks = 5